'use client';

import { PropsWithChildren } from 'react';

import { InitWebviewInfo } from '@flipster/features/src/shared/webview';

const Template = ({ children }: PropsWithChildren) => {
  return (
    <>
      <InitWebviewInfo />

      {children}
    </>
  );
};

export default Template;
